import React, { Component } from 'react';
import Header from './../../containers/HeaderContainer';
import GameWrapperContainer from '../../containers/GameWrapperContainer';
import MailListContainer from '../../containers/mailListContainer/MailListContainer';
import MailHeaderContainer from '../../containers/mailHeaderContainer';
import Footer from './../../containers/FooterContainer';

class WelcomeScreen extends Component {
    render() {
        const isMailThreadView = false;
        return <GameWrapperContainer match={this.props.match}>
            <Header />
            <div className="mail-container">
                <MailHeaderContainer match={this.props.match} isMailThreadView={isMailThreadView} />
                <MailListContainer {...this.props} />
            </div>
            <Footer {...this.props} />
        </GameWrapperContainer>;
    }
}
export default WelcomeScreen;


// WEBPACK FOOTER //
// /src/screens/MailList/index.js